/**
 * Use a "container" component to contain any logic to map Redux store state into component props,
 * and map any Redux actions into component props.
 * Useful for separating business logic from rendering logic; makes it easier to re-use the rendering logic but apply different business logic.
 * Also useful for introducing test frameworks in future, as we can easily pass mock data to the rendering layer.
 */

import { connect } from 'react-redux';

import TestWidget from '.';

/**
 * Use redux selector functions to map state from the redux store into component props
 *
 * @param state
 * @param ownProps
 */
const mapStateToProps = (state, ownProps) => ({
    matchItem: PULSE.app.redux.selectors.match.item(state, ownProps.data.pid)
});

/**
 * Need to use this form of "mapDispatchToProps" to ensure the PULSE namespace resolves correctly
 *
 * @param dispatch
 * @param ownProps
 */
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        addMatch: (matchId) =>
            dispatch(PULSE.app.redux.actions.match.ADD_MATCH.request(matchId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TestWidget);
